import {Module} from "vuex";
interface IPagingState{
    perPage: number;
    page: number;
    totalCount: number;
}
export default <Module<IPagingState, any>>{
    state:{
        perPage: 10,
        page: 1,
        totalCount: 0,
    },
    mutations:{
        setPerPage(state, count = 10){
            state.perPage = Math.max(1, count || 10);
            // Корректировка текущей страницы, чтобы она не выходила за пределы нового количества страниц
            if (state.totalCount > 0) {
                const pageCount = Math.max(1, Math.ceil(state.totalCount / state.perPage));
                state.page = Math.max(1, Math.min(state.page, pageCount));
            }
        },
        setPage(state, page = 1){
            // state.page = page
            // const pageCount = Math.max(1, Math.ceil(state.totalCount / state.perPage));
            // state.page = Math.max(1, Math.min(page, pageCount)); // 1-based

            if (state.totalCount === 0) {
                state.page = page;
            } else {
                const pageCount = Math.max(1, Math.ceil(state.totalCount / state.perPage));
                state.page = Math.max(1, Math.min(page, pageCount)); // 1-based
            }

        },
        setTotalCount(state, count = 0){
            // state.totalCount = count;
            state.totalCount = Math.max(0, count || 0);
            const pageCount = Math.max(1, Math.ceil(state.totalCount / state.perPage));
            state.page = Math.max(1, Math.min(state.page, pageCount));
        },
    },
    actions:{
    },
    getters:{
        perPage: (state):number => state.perPage,
        page: (state):number => state.page,
        totalCount: (state):number => state.totalCount,
        offsetRows: (state, getters):number => (getters.page - 1) * getters.perPage,
        getPageZeroBased: ({ page }) => page - 1,
        pageCount: (state, getters):number => Math.max(1, Math.ceil(state.totalCount / getters.perPage)),
        // pageCount: (state, getters):number => Math.ceil(getters.totalCount / getters.perPage),
    },
};
